import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

type NewsroomEmptyStateProps = {
  variant: 'noSubscriptions' | 'noAlerts'
  onOpenSettings?: () => void
}

export function NewsroomEmptyState({
  variant,
  onOpenSettings,
}: NewsroomEmptyStateProps) {
  const { t } = useTranslation('regulatory-alerts')

  const titleKey =
    variant === 'noSubscriptions'
      ? 'inbox.emptyNoSubscriptionsTitle'
      : 'inbox.emptyNoAlertsTitle'
  const descriptionKey =
    variant === 'noSubscriptions'
      ? 'inbox.emptyNoSubscriptionsDescription'
      : 'inbox.emptyNoAlertsDescription'

  return (
    <div className='rounded-lg border border-dashed p-8 text-center'>
      <h2 className='text-lg font-semibold'>{t(titleKey)}</h2>
      <p className='mt-2 text-sm text-muted-foreground'>{t(descriptionKey)}</p>
      {variant === 'noSubscriptions' && onOpenSettings ? (
        <Button className='mt-4' variant='outline' onClick={onOpenSettings}>
          {t('inbox.goToSettings')}
        </Button>
      ) : null}
    </div>
  )
}
